import React, { useMemo } from "react";
import "../pages/styles/cartAddBar.css";
import { AiOutlineHome } from "react-icons/ai";
import { FiPhoneCall } from "react-icons/fi";
import { PiShoppingCartSimpleLight } from "react-icons/pi";

/**
 * ✅ Jumia-like bottom bar
 * - Before add: shows big "Add To Cart" button
 * - After add (inCart=true): replaces the button with a quantity stepper (+ / -) ONLY
 */
const CartAddBar = ({
  show = true,

  disabled = false,
  inCart = false,

  qty = 1,
  minQty = 1,
  onDecQty,
  onIncQty,

  onHome,
  onCall,

  onAddToCart, // used only when NOT in cart
  ctaText,     // optional label override for Add button
}) => {
  // ✅ hooks first
  const safeQty = useMemo(
    () => Math.max(Number(minQty || 1), Number(qty || 1)),
    [qty, minQty]
  );

  const addLabel = useMemo(() => {
    if (ctaText) return ctaText;
    return "Add To Cart";
  }, [ctaText]);

  // ✅ early return after hooks
  if (!show) return null;

  const onAdd = () => {
    if (disabled) return;
    onAddToCart?.();
  };

  const canDec = safeQty > Math.max(1, Number(minQty || 1));

  return (
    <div className="cab-wrap" role="region" aria-label="Cart action bar">
      <div className="cab-inner">
        {/* LEFT: icon buttons */}
        <div className="cab-actions" aria-label="Quick actions">
          <button
            type="button"
            className="cab-iconBtn"
            onClick={onHome}
            aria-label="Home"
          >
            <AiOutlineHome className="cab-ic" />
          </button>

          <button
            type="button"
            className="cab-iconBtn"
            onClick={onCall}
            aria-label="Call"
          >
            <FiPhoneCall className="cab-ic" />
          </button>
        </div>

        {/* RIGHT: either Add button OR qty stepper */}
        {!inCart ? (
          <button
            type="button"
            className="cab-cta"
            onClick={onAdd}
            disabled={disabled}
            aria-label={addLabel}
          >
            <PiShoppingCartSimpleLight className="cab-ctaIcon" />
            <span className="cab-ctaText">{addLabel}</span>
          </button>
        ) : (
          <div className="cab-qty cab-qty--full" role="group" aria-label="Quantity selector">
            <button
              type="button"
              className="cab-qtyBtn"
              onClick={onDecQty}
              aria-label="Decrease quantity"
              disabled={disabled || !canDec}
            >
              −
            </button>

            <div className="cab-qtyVal" aria-label="Quantity value">
              {safeQty}
            </div>

            <button
              type="button"
              className="cab-qtyBtn"
              onClick={onIncQty}
              aria-label="Increase quantity"
              disabled={disabled}
            >
              +
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default CartAddBar;
